<template>
  <div id="app">
      <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  components: {
  }
};
</script>

<style>
html,body,#app {
  height: 100%;
  margin:0;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  background: #ffffff;
}
ol,ul {list-style:none} 
a{text-decoration: none;color:#333;}
.qingwu{height: 100%;}

/*  全局修改滚动条样式 */
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: #CCCCCC;
    position: absolute;
    right: 0;
    bottom: 0;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #fff;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    background-color: #CCCCCC;
}

/* 分页器颜色全局修改  */
.el-pagination.is-background .el-pager li:hover{
    color: #606266 !important
}
.el-pagination.is-background .el-pager li.active:hover{
    color: #fff !important
}
.el-pagination.is-background .el-pager li:not(.disabled).active{
    color: #fff;
  }
  .el-pagination.is-background .el-pager li.active {
    color: #fff;
    cursor: default;
  }
  .el-pagination.is-background .el-pager li:hover {
    color: #fff;
  }
  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #fff;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active:hover {
    color: #fff;
  }
  .el-pagination .el-select .el-input .el-input__inner:hover {
    border-color: #C0C4CC !important;
  }
  .el-input.is-active .el-input__inner,
  .el-input__inner:focus {
    border-color: #C0C4CC !important;
  }


  .mouse-cover-canvas{
    width: 400px !important;
    height: 400px !important;
    display: none;
  }
</style>
